document.addEventListener("DOMContentLoaded", () => {
  setDefaultActiveVariantSwatch();
  handleVariantSwatchClick();
  handleProductDescriptionClick();
});

function setDefaultActiveVariantSwatch() {
  const swatches = [...document.querySelectorAll('[js-product-swatches="swatch"]')];
  const variantSelect = document.querySelector('#ProductSelect-product-template');

  if (!swatches || !variantSelect) {
    return;
  }

  const variantOptions = variantSelect.options;
  const activeIndex = Array.from(variantOptions).findIndex(option => option.selected);

  swatches[activeIndex].classList.add('is-active');
}

function handleVariantSwatchClick() {
  const swatches = [...document.querySelectorAll('[js-product-swatches="swatch"]')];
  const variantSelect = document.querySelector('#ProductSelect-product-template');

  if (!swatches || !variantSelect) {
    return;
  }

  const variantOptions = variantSelect.options;

  swatches.forEach((swatch) => {
    swatch.addEventListener("click", (event) => {
      if (event.target?.classList.contains('swatch__label--sold-out')) {
        return;
      }
      
      const variantId = event.target?.dataset.variantId;

      if (!variantId) {
        return;
      }

      unselectAllVariantOptions(swatches);
      event.target.classList.add('is-active');

      const optionIndex = Array.from(variantOptions).findIndex(option => option.value === variantId);

      if (!optionIndex) {
        return;
      }
      
      variantSelect.selectedIndex = optionIndex;
    });
  });
}

function unselectAllVariantOptions(swatches) {
  swatches.forEach((swatch) => {
    swatch.classList.remove('is-active');
  });
}

function handleProductDescriptionClick() {
  const lengthToggles = [...document.querySelectorAll('[js-product-description="lengthToggle"]')];
  const shortDescription = document.querySelector('[js-product-description="short"]');
  const fullDescription = document.querySelector('[js-product-description="full"]');

  if (!lengthToggles || !shortDescription || !fullDescription) {
    return;
  }

  lengthToggles.forEach((toggle) => {
    toggle.addEventListener("click", () => {
      shortDescription.classList.toggle('is-hidden');
      fullDescription.classList.toggle('is-hidden');
    });
  });
}